{
    "back": "Atgal",
    "cancel": "Atšaukti",
    "delete": "Panaikinti",
    "dismiss": "Atmesti",
    "done": "baigta",
    "donor_feedback_anonymized": "Dėl duomenų apsaugos priežasčių jau anonimizavome jūsų duomenis.",
    "donor_feedback_incorrect_link": "Naudojama nuoroda neteisinga – įsitikinkite, kad naudojate visą jums atsiųstą nuorodą.",
    "donor_feedback_not_found": "Deja, ši nuoroda neteisinga. Taip gali būti dėl vienos iš šių priežasčių:",
    "error_occurred": "Įsivėlė klaida",
    "expired": "Pasibaigęs",
    "field_error_address_unsupported_country": "Adresas nėra priimtinoje šalyje",
    "field_error_any": "Pateikite bent vieną iš šių laukų: ${1}",
    "field_error_date_invalid": "Nurodykite tinkamą datą",
    "field_error_date_max": "Data turi būti ${1} arba ankstesnė",
    "field_error_date_min": "Data turi būti ${1} arba vėlesnė",
    "field_error_date_range_max": "Data turi būti ankstesnė nei ${1}",
    "field_error_date_range_min": "Data turi būti vėlesnė nei ${1}",
    "field_error_email": "Nurodykite tinkamą el. pašto adresą",
    "field_error_length_max": "Šiame lauke yra iki ${1} simbolių",
    "field_error_length_min": "Pateikite mažiausiai ${1} simbolių",
    "field_error_max": "Didžiausia vertė yra ${1}",
    "field_error_min": "Mažiausia vertė yra ${1}",
    "field_error_pattern": "Įvestis neteisinga",
    "field_error_phone_invalid": "Nurodykite tinkamą telefono numerį",
    "field_error_phone_starts_with_zero": "Šalies kodas jau egzistuoja. Iš telefono numerio pašalinkite pradinį \"0\".",
    "field_error_required": "Užpildykite šį lauką",
    "field_is_required": "Šis laukas privalomas",
    "field_placeholder_address_search": "Įveskite vietovę",
    "field_select_not_found": "„${1}“ rasti nepavyko",
    "font_big": "didelis šriftas",
    "font_medium": "vidutinis šriftas",
    "font_small": "mažas šriftas",
    "link_sent": "Nuoroda išsiųsta, patikrinkite",
    "network_error": "Tinklo klaida",
    "no_results": "Jokių rezultatų",
    "offline": "atsijungęs",
    "ok": "Gerai",
    "online": "prisijungęs",
    "open": "atidaryta",
    "page_not_found_description": "Puslapio, kurio užklausą bandėte pateikti, nėra. Gali būti, kad neteisingai įvedėte URL adresą.",
    "page_not_found_link": "Grįžti į pradinį puslapį.",
    "page_not_found_title": "Puslapis nerastas",
    "retry": "Bandykite dar kartą",
    "save": "Išsaugoti",
    "state_refused": "Atsisakė",
    "type": "Tipas",
    "uploading": "Įkeliama..."
}